import { AuthGuard } from 'admin-web-ui'
import { AuthGroups, Service } from 'admin-web-utils'
import React from 'react'
import { Navigate, useLocation } from 'react-router'
import { NewRouteDefinition } from '../../../routes'

interface ProjectPageProps {
  authGroups: AuthGroups
  projectId: string
  route: NewRouteDefinition
  projectServices: Service[]
}

export const ProjectPage: React.FC<ProjectPageProps> = (props) => {
  const { pathname, search } = useLocation()
  const { authGroups, projectId, route, projectServices } = props

  return (
    <AuthGuard
      authGroups={authGroups}
      projectId={projectId}
      required={route.requiredAuth}
      noAuthFallback={<Navigate to={`/login?ret=${pathname + search}`} />}
    >
      {route.requiredService &&
      !projectServices.some((ps) => ps.id === route.requiredService?.serviceId)
        ? route.requiredService.teaserComponent
        : route.element}
    </AuthGuard>
  )
}
